<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="image"><a id="page_v"></a><img alt="Image" src="images/f00vi-01.jpg"/></p>
<p class="center-para">Holt Paperbacks<br/>Henry Holt and Company, LLC<br/><em>Publishers since 1866</em><br/>175 Fifth Avenue<br/>New York, New York 10010<br/><a href="http://www.henryholt.com" target="_blank">www.henryholt.com</a></p>
<p class="para"> </p>
<p class="center-para">A Holt Paperback<sup>®</sup> and <img alt="Image" src="images/f00vi-02.jpg"/><sup>®</sup> are registered trademarks of<br/>Henry Holt and Company, LLC.</p>
<p class="para"> </p>
<p class="center-para">Copyright © 2006 by Thomas A. Reppetto<br/>All rights reserved.</p>
<p class="center-para">Distributed in Canada by H. B. Fenn and Company Ltd.</p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<p class="para">Reppetto, Thomas A.</p>
<blockquote>
<p class="para">Bringing down the mob : the war against the American Mafia / Thomas A. Reppetto.</p>
<p class="indent-para"> p. cm.</p>
<p class="para">Includes bibliographical references and index.</p>
<p class="para">ISBN-13: 978-0-8050-8659-1</p>
<p class="para">ISBN-10: 0-8050-8659-5</p>
<p class="indent-para">1. Mafia—United States. 2. Organized crime—United States. 3. Organized crime investigation—United States. I. Title.</p>
<p class="para">HV6446.R473 2006</p>
</blockquote>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="para">364.106'0973—dc22</p></td>
<td valign="top"><p class="right-para">2006043704</p></td>
</tr>
</tbody></table>
<p class="center-para">Henry Holt books are available for special promotions and<br/>premiums. For details contact: Director, Special Markets.</p>
<p class="para"> </p>
<p class="center-para">Originally published in hardcover in 2006 by<br/>John Macrae / Henry Holt and Company</p>
<p class="para"> </p>
<p class="center-para">First Holt Paperbacks Edition 2009</p>
<p class="para"> </p>
<p class="center-para"><em>Designed by Kelly Too</em></p>
<p class="para"> </p>
<p class="center-para">Printed in the United States of America</p>
<p class="center-para">1   3   5   7   9   10   8   6   4   2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?a2e66578